/**
 * Modal d'affichage des résultats de "Verif. intérêts opposés".
 *
 * Equivalent legacy `FrmListDivers` (Forms/FrmListDivers.vb) ouvert depuis
 * `btnVerifIntOppose_Click` dans MDIParent2.vb:1083-1088. Le titre legacy est :
 *   "DAJ ayant le conjoint {prenom} {nom} comme requérant principal"
 *
 * Colonnes affichées (parité exacte ChercheIntOpp - CodeDaj.vb:1051) :
 *   Date demande, No bureau, Nom Requérant, Prénom Requérant, Adresse Req,
 *   Nom Conjoint, Prénom Conjoint, Adresse Conjoint, Nature,
 *   No avocat, Nom avocat, pk_daj.
 */
const InteretsOpposesResultsModal = ({ data, onClose }) => {
  if (!data) return null;
  const { results, nom, prenom } = data;

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        zIndex: 3000,
      }}
      data-testid="modal-intoppose-results"
    >
      <div
        style={{
          backgroundColor: '#f0f0f0',
          border: '2px solid #333',
          width: '90vw',
          maxWidth: '1400px',
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '4px 4px 12px rgba(0,0,0,0.4)',
        }}
      >
        <div
          style={{
            backgroundColor: '#1d4ed8',
            color: 'white',
            padding: '8px 14px',
            fontWeight: 'bold',
            fontSize: '14px',
          }}
        >
          {`DAJ ayant le conjoint ${prenom} ${nom} comme requérant principal`}
        </div>
        <div style={{ padding: '12px', overflow: 'auto', flex: 1 }}>
          <table className="win-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#d0d0d0' }}>
                <th style={thStyle}>Date demande</th>
                <th style={thStyle}>No bureau</th>
                <th style={thStyle}>Nom Requérant</th>
                <th style={thStyle}>Prénom Requérant</th>
                <th style={thStyle}>Adresse requérant</th>
                <th style={thStyle}>Nom Conjoint</th>
                <th style={thStyle}>Prénom Conjoint</th>
                <th style={thStyle}>Adresse conjoint</th>
                <th style={thStyle}>Nature</th>
                <th style={thStyle}>No avocat</th>
                <th style={thStyle}>Nom avocat</th>
                <th style={thStyle}>pk_daj</th>
              </tr>
            </thead>
            <tbody>
              {results.map((r, idx) => (
                <tr
                  key={r.pk_daj || idx}
                  data-testid="intoppose-result-row"
                  style={{ background: idx % 2 ? '#fafafa' : 'white' }}
                >
                  <td style={tdStyle}>{r.date_demande}</td>
                  <td style={tdStyle}>{r.nobur}</td>
                  <td style={tdStyle}>{r.nom_requerant}</td>
                  <td style={tdStyle}>{r.prenom_requerant}</td>
                  <td style={tdStyle}>{r.adresse_requerant}</td>
                  <td style={tdStyle}>{r.nom_conjoint}</td>
                  <td style={tdStyle}>{r.prenom_conjoint}</td>
                  <td style={tdStyle}>{r.adresse_conjoint}</td>
                  <td style={tdStyle}>{r.nature}</td>
                  <td style={tdStyle}>{r.no_avocat}</td>
                  <td style={tdStyle}>{r.nom_avocat}</td>
                  <td style={{ ...tdStyle, fontFamily: 'monospace', fontSize: 11 }}>{r.pk_daj}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: 8, fontSize: 11, color: '#555' }}>
            {`${results.length} dossier(s) trouvé(s)`}
          </div>
        </div>
        <div
          style={{
            padding: '10px 14px',
            borderTop: '1px solid #999',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 10,
          }}
        >
          <button
            className="win-btn"
            onClick={onClose}
            data-testid="btn-close-intoppose"
            style={{ padding: '6px 22px', fontWeight: 'bold' }}
          >
            Continuer
          </button>
        </div>
      </div>
    </div>
  );
};

const thStyle = {
  border: '1px solid #888',
  padding: '4px 8px',
  textAlign: 'left',
  fontWeight: 'bold',
};
const tdStyle = {
  border: '1px solid #ccc',
  padding: '3px 6px',
};

export default InteretsOpposesResultsModal;
